import { render, staticRenderFns } from "./EventTypeList.vue?vue&type=template&id=856e6edc"
import script from "./EventTypeList.vue?vue&type=script&lang=js"
export * from "./EventTypeList.vue?vue&type=script&lang=js"
import style0 from "./EventTypeList.vue?vue&type=style&index=0&id=856e6edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports